import { render, staticRenderFns } from "./FixerFormUserMediaTypeDisableSocial.vue?vue&type=template&id=38531d8e&"
import script from "./FixerFormUserMediaTypeDisableSocial.vue?vue&type=script&lang=ts&"
export * from "./FixerFormUserMediaTypeDisableSocial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCard,VCardActions,VCardText,VCardTitle,VContainer,VDialog,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38531d8e')) {
      api.createRecord('38531d8e', component.options)
    } else {
      api.reload('38531d8e', component.options)
    }
    module.hot.accept("./FixerFormUserMediaTypeDisableSocial.vue?vue&type=template&id=38531d8e&", function () {
      api.rerender('38531d8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/import/fixer/FixerFormUserMediaTypeDisableSocial.vue"
export default component.exports